import { useRecoilState, useRecoilValue } from "recoil";
import { deviceListState } from "../atom/atom";
import { Device, Token } from "../types/type";
import PushNotificationForm from "../components/PushNotificationForm";
import { useEffect, useState } from "react";
import { fetchAndSetData, fetchDeviceList } from "../api/fetch.api";
import { Box, Button, Container, Input, Typography } from "@mui/material";
import { PSEUDOID_USERID_DATA, PseudoIdUser } from "../dummy";
import { formatDate } from "../tools/tools";

function PseudoIdPage() {
  const [deviceList, setDeviceList] = useRecoilState(deviceListState);
  const [matchedDevices, setMatchedDevices] = useState<
    (PseudoIdUser & { devices: Device[] })[]
  >([]);
  const [pseudoIdUserData, setPseudoIdUserData] =
    useState<PseudoIdUser[]>(PSEUDOID_USERID_DATA);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target?.result;
        if (content) {
          try {
            const jsonData = JSON.parse(content as string);
            setPseudoIdUserData(jsonData);
          } catch (error) {
            console.error("Error parsing JSON file", error);
          }
        }
      };
      reader.readAsText(file);
    }
  };

  useEffect(() => {
    fetchAndSetData(fetchDeviceList, setDeviceList);
  }, [setDeviceList]);

  useEffect(() => {
    const matched = pseudoIdUserData.map((item) => {
      const devices = deviceList.filter(
        (device) => device.hashedDeviceId === item.user_id
      );
      return { ...item, devices };
    });
    console.log("matched : ", matched);
    setMatchedDevices(matched);
  }, [deviceList, pseudoIdUserData]);

  return (
    <Container>
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Device Information Finder
        </Typography>
        <Box my={2}>
          <Button variant="contained" component="label">
            Upload JSON File
            <Input type="file" hidden onChange={handleFileUpload} />
          </Button>
        </Box>
        {matchedDevices.map((item) => (
          <Box key={item.user_pseudo_id} mt={4} p={2} border={1}>
            <Typography variant="h6">
              User Pseudo ID: {item.user_pseudo_id}
            </Typography>
            <Typography>User ID: {item.user_id}</Typography>
            {item.devices.length > 0 ? (
              item.devices.map((device) => (
                <Box key={device.deviceId} mt={2} p={2} border={1}>
                  <Typography>ID: {device.deviceId}</Typography>
                  <Typography>
                    Hashed Device ID: {device.hashedDeviceId}
                  </Typography>
                  <Typography>FCM Token: {device.fcmToken}</Typography>
                  <Typography>User Name: {device.userName}</Typography>
                  <Typography>Email: {device.email}</Typography>
                  <Typography>Platform: {device.platform}</Typography>
                  <Typography>
                    Recently Used At: {formatDate(device.recentlyUseAt)}
                  </Typography>
                  <Typography>Tags: {JSON.stringify(device.tag)}</Typography>
                </Box>
              ))
            ) : (
              <Typography>디바이스 결과 없음</Typography>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
}

export default PseudoIdPage;
